export const COUNTRY_STATES = {
  AU: [
    { state_code: 'ACT', state_name: 'ACT' },
    { state_code: 'NSW', state_name: 'NSW' },
    { state_code: 'NT', state_name: 'NT' },
    { state_code: 'QLD', state_name: 'QLD' },
    { state_code: 'SA', state_name: 'SA' },
    { state_code: 'TAS', state_name: 'TAS' },
    { state_code: 'VIC', state_name: 'VIC' },
    { state_code: 'WA', state_name: 'WA' },
  ],
  CA: [
    { state_code: 'AB', state_name: 'AB' },
    { state_code: 'BC', state_name: 'BC' },
    { state_code: 'MB', state_name: 'MB' },
    { state_code: 'NB', state_name: 'NB' },
    { state_code: 'NL', state_name: 'NL' },
    { state_code: 'NS', state_name: 'NS' },
    { state_code: 'NT', state_name: 'NT' },
    { state_code: 'NU', state_name: 'NU' },
    { state_code: 'ON', state_name: 'ON' },
    { state_code: 'PE', state_name: 'PE' },
    { state_code: 'QC', state_name: 'QC' },
    { state_code: 'SK', state_name: 'SK' },
    { state_code: 'YT', state_name: 'YT' },
  ],
  US: [
    { state_code: 'AA', state_name: 'AA' },
    { state_code: 'AE', state_name: 'AE' },
    { state_code: 'AL', state_name: 'AL' },
    { state_code: 'AK', state_name: 'AK' },
    { state_code: 'AP', state_name: 'AP' },
    { state_code: 'AS', state_name: 'AS' },
    { state_code: 'AZ', state_name: 'AZ' },
    { state_code: 'AR', state_name: 'AR' },
    { state_code: 'CA', state_name: 'CA' },
    { state_code: 'CO', state_name: 'CO' },
    { state_code: 'CT', state_name: 'CT' },
    { state_code: 'DE', state_name: 'DE' },
    { state_code: 'DC', state_name: 'DC' },
    { state_code: 'FM', state_name: 'FM' },
    { state_code: 'FL', state_name: 'FL' },
    { state_code: 'GA', state_name: 'GA' },
    { state_code: 'GU', state_name: 'GU' },
    { state_code: 'HI', state_name: 'HI' },
    { state_code: 'ID', state_name: 'ID' },
    { state_code: 'IL', state_name: 'IL' },
    { state_code: 'IN', state_name: 'IN' },
    { state_code: 'IA', state_name: 'IA' },
    { state_code: 'KS', state_name: 'KS' },
    { state_code: 'KY', state_name: 'KY' },
    { state_code: 'LA', state_name: 'LA' },
    { state_code: 'ME', state_name: 'ME' },
    { state_code: 'MH', state_name: 'MH' },
    { state_code: 'MD', state_name: 'MD' },
    { state_code: 'MA', state_name: 'MA' },
    { state_code: 'MI', state_name: 'MI' },
    { state_code: 'MN', state_name: 'MN' },
    { state_code: 'MP', state_name: 'MP' },
    { state_code: 'MS', state_name: 'MS' },
    { state_code: 'MO', state_name: 'MO' },
    { state_code: 'MT', state_name: 'MT' },
    { state_code: 'NE', state_name: 'NE' },
    { state_code: 'NV', state_name: 'NV' },
    { state_code: 'NH', state_name: 'NH' },
    { state_code: 'NJ', state_name: 'NJ' },
    { state_code: 'NM', state_name: 'NM' },
    { state_code: 'NY', state_name: 'NY' },
    { state_code: 'NC', state_name: 'NC' },
    { state_code: 'ND', state_name: 'ND' },
    { state_code: 'MP', state_name: 'MP' },
    { state_code: 'OH', state_name: 'OH' },
    { state_code: 'OK', state_name: 'OK' },
    { state_code: 'OR', state_name: 'OR' },
    { state_code: 'PW', state_name: 'PW' },
    { state_code: 'PA', state_name: 'PA' },
    { state_code: 'PR', state_name: 'PR' },
    { state_code: 'RI', state_name: 'RI' },
    { state_code: 'SC', state_name: 'SC' },
    { state_code: 'SD', state_name: 'SD' },
    { state_code: 'TN', state_name: 'TN' },
    { state_code: 'TX', state_name: 'TX' },
    { state_code: 'UT', state_name: 'UT' },
    { state_code: 'VT', state_name: 'VT' },
    { state_code: 'VI', state_name: 'VI' },
    { state_code: 'VA', state_name: 'VA' },
    { state_code: 'WA', state_name: 'WA' },
    { state_code: 'WV', state_name: 'WV' },
    { state_code: 'WI', state_name: 'WI' },
    { state_code: 'WY', state_name: 'WY' },
  ],
};

export const COUNTRY_POSTAL_CODE_REGEX = {
  US: /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] *\d[A-Z]\d)$/,
  CA: /^.{5,7}$/,
};
